import { gql } from '../../../__generated__/graphql/catalog'

export const FETCH_CHECKOUT_URL = gql(`
  query fetchCheckoutUrl($cartId: String!) {
    retrieveCheckoutUrl(cartId: $cartId) {
      checkoutUrl
      userErrors {
        code
        field
        message
      }
      warnings {
        code
        message
        target
      }
    }
  }
`)
